export default "__VITE_PUBLIC_ASSET__67277419__"